/* eslint-disable  */
import Image from 'next/image';

import primaryCTA from '@/assets/images/icons/Primary-CTA_Large.svg';

export const HomeDownloadCta = (props: any) => {
  const {
    // title,
    desc,
    googleStoreLink,
    appleStoreLink,
    bannerImageSrc,
    bannerImageAlt,
  } = props;
  return (
    <section className="bg bg--dark downloadCta pb-0">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-7">
            <h2 className="section__title text--white">
              Download India’s Most Trusted{' '}
              <span className="text--yellow">Digital Gold App</span>
            </h2>
            <p className="section__desc text--white-80">{desc}</p>
            <div className="d-flex align-items-center appLinks">
              {/* <a href={googleStoreLink} target="_blank">
                <Image 
style={{ color: undefined }}
                  className="img-fluid"
                  src={playStore}
                  alt="Google Play Store"
                />
                <span className="sr-only">Google Play Store</span>
              </a>
              <a href={appleStoreLink} target="_blank">
                <Image 
style={{ color: undefined }} className="img-fluid" src={appStore} alt="App Store" />
                <span className="sr-only">App Store</span>
              </a> */}
              <a href="https://qrco.de/mfone" target="_blank">
                <Image
                  style={{ color: undefined }}
                  // width={32}
                  // height={32}
                  // className="img-fluid"
                  src={primaryCTA}
                  alt="Google Play Store"
                />
                <span className="sr-only">Google Play Store</span>
              </a>
            </div>
          </div>
          <div className="col-lg-5">
            <Image
              style={{ color: undefined }}
              className="img-fluid right-image"
              src={bannerImageSrc}
              alt={bannerImageAlt}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
